var _path, _ellipse, _circle, _circle2, _ellipse2, _ellipse3, _path2, _path3, _circle3, _circle4, _circle5, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFoundPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 143,
    viewBox: "0 0 198 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 98C105.552 98 106 97.5523 106 97C106 96.4477 105.552 96 105 96V98ZM151 50C151 50.5523 151.448 51 152 51C152.552 51 153 50.5523 153 50H151ZM18 2H148V0H18V2ZM15 93V5H13V93H15ZM105 96H18V98H105V96ZM151 5V50H153V5H151ZM13 93C13 95.7614 15.2386 98 18 98V96C16.3431 96 15 94.6569 15 93H13ZM148 2C149.657 2 151 3.34315 151 5H153C153 2.23858 150.761 0 148 0V2ZM18 0C15.2386 0 13 2.23858 13 5H15C15 3.34315 16.3431 2 18 2V0Z",
    fill: "#053668"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 82,
    cy: 101,
    rx: 82,
    ry: 4,
    fill: "#053668"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 47.5,
    r: 4.5,
    fill: "#053668"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.5,
    cy: 47.5,
    r: 4.5,
    fill: "#053668"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 60.5,
    cy: 56.5,
    rx: 5.5,
    ry: 2.5,
    fill: "#053668"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 105.5,
    cy: 56.5,
    rx: 5.5,
    ry: 2.5,
    fill: "#053668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63C89 60 86.3137 58 83 58C79.6863 58 77 60 76 63",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4C14 2.34315 15.3431 1 17 1H149C150.657 1 152 2.34315 152 4V10H14V4Z",
    fill: "#053668"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 5,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 5,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 5,
    r: 2,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.213 62.7868C171.929 74.5025 171.929 93.4975 160.213 105.213C148.497 116.929 129.502 116.929 117.787 105.213C106.071 93.4975 106.071 74.5025 117.787 62.7868C129.502 51.0711 148.497 51.0711 160.213 62.7868Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.213 105.213C171.929 93.4975 171.929 74.5025 160.213 62.7868C148.497 51.0711 129.502 51.0711 117.787 62.7868C106.071 74.5025 106.071 93.4975 117.787 105.213C129.502 116.929 148.497 116.929 160.213 105.213ZM160.213 105.213L173 118",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119 100H151C153.209 100 155 98.2091 155 96V64",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundPage);
export default __webpack_public_path__ + "static/media/not-found-page.d44a1456.svg";
export { ForwardRef as ReactComponent };